<template>
  <v-dialog v-model="value" persistent max-width="600px">
        <material-card
          color="orange"
          title="MedDRA"
          text="Upload new version"
        >
          <v-form ref="form" v-model="validForm" autocomplete="off">
            <v-container py-0>
              <v-layout wrap>
              
                <v-flex xs12 md12 style="margin-top:15px">
                  <v-file-input
                    v-model="item.zipfile"
                    truncate-length="30"
                    label="MedDRA zip file"
                    accept="application/zip"
                    :rules="[v=>!!v || 'Zip file is required']"
                    required>
                  </v-file-input>
                </v-flex>

              
                <v-flex xs12 md12>
                  <v-text-field
                    autocomplete="off"
                    v-model="item.password"
                    prepend-icon="mdi-lock"
                    :append-icon="
                      passwordType == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showPwd"
                    label="Zip file password"
                    :type="passwordType"
                    required
                    :name="Math.random()"
                  >
                  </v-text-field>
                </v-flex>



                <v-flex xs12 text-right>
                  
                  <v-btn
                    color="primary"
                    class="mx-1 font-weight-light"
                    @click="close()">Close</v-btn>

                  <v-btn
                    color="orange"
                    class="mx-1 font-weight-light"
                    @click="confirm"
                    :disabled="!validForm || loading"
                    :loading="loading"
                    >Confirm</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
  </v-dialog>
</template>

<script>
import { uploadZip } from "@/api/meddra"
import validators from "@/utils/validators"

export default {
  props: {
    value: { type: Boolean, default: true }
  },
  data: () => ({
    item: {},
    validForm: true,
    loading: false,
    validators,
    passwordType: 'password'
  }),
  watch: {
    value(v) {
      if (v && this.$refs.form) {
        this.$refs.form.reset()
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false)
    },
    confirm() {

      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('zip', this.item.zipfile);
      formData.append('password', this.item.password);
      this.loading = true
      uploadZip(formData).then( data => {
        
        this.$root.$emit('openSnackbar', {
            message: 'MedDRA successfully updated to the version ' + data.version,
            color: 'success'
        })

        // REPORT
        var encodedUri = encodeURI(data.csv_report);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data.csv_report));
        link.setAttribute("download", "meddra_update_report.csv");
        document.body.appendChild(link); // Required for FF
        link.click(); // This will download the data file named "my_data.csv".


      }).catch( (data) => {
          this.$root.$emit('openSnackbar', {
            message: 'An Error occurred during the MedDRA zip upload : ' +
              data.response.data.message.toUpperCase() || 'Error',
            color: 'warning'
          })
         
         
      }).finally( () => {
        this.loading = false
      });

    },
    showPwd () {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
  },
 
}
</script>
